<template>
    <Typography
        is="div"
        v-if="appStore.isDebugMode && storageOuterMessage"
        size="m"
        :class="$style.storage_message"
    >
        {{ storageOuterMessage }}
    </Typography>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import Typography from '@/components_new/Typography.vue'
import { MessageAction } from '@/modules/main-frame/message-types'
import { useAppStore } from '@/store/app-store'

const props = defineProps<{
    saveEvent: { type: 'cloud-save' | 'storage'; action: MessageAction } | null
}>()

const appStore = useAppStore()
const storageOuterMessage = ref<string>('')
const storageOuterMessageResetTimeout = ref<number>()

function showStorageOuterMessage(event: { type: 'cloud-save' | 'storage'; action: MessageAction }) {
    storageOuterMessage.value = `YOU ARE IN DEBUG MODE! event: ${event.type} - action: ${MessageAction.setItems}`
    if (storageOuterMessageResetTimeout.value) {
        clearTimeout(storageOuterMessageResetTimeout.value)
    }
    storageOuterMessageResetTimeout.value = window.setTimeout(() => {
        storageOuterMessage.value = ''
        storageOuterMessageResetTimeout.value = undefined
    }, 3000) // reset last message in 3 sec
}

watch(
    () => props.saveEvent,
    (event) => {
        if (!event || !appStore.isDebugMode) {
            return
        }
        showStorageOuterMessage(event)
    },
)
</script>
<style module>
.storage_message {
    background-color: red;
    height: 30px;
    position: absolute;
    text-align: center;
    padding: 10px 10px;
    top: 0;
    left: 0;
    right: 0;
}
</style>
